import { Component, Input } from '@angular/core';
import { MaRound } from '../pojo/ma-classes';
import { ExcelService } from 'src/app/domain/excel';
import { ExcelTemplateName } from 'src/app/domain/excel/interfaces';

@Component({
  selector: 'app-ma-all-rounds',
  templateUrl: './ma-all-rounds.component.html',
  styleUrls: ['./ma-all-rounds.component.scss'],
})
export class MaAllRoundsComponent {
  @Input()
  set setRounds(rounds: MaRound[]) {
    this.rounds = rounds;
  }

  rounds: MaRound[] = [];
  headers = MA_ALL_ROUNDS_HEADERS;
  sortMap = SORT_MAP;
  maAllRoundsSort = MA_ALL_ROUNDS_SORTING;

  constructor(private excelService: ExcelService) { }

  exportExcel(): void {
    const fileName = 'ma-all-rounds.xlsx';
    this.excelService.exportByTemplate(this.rounds, fileName, ExcelTemplateName.maAllRounds);
  }
}

export const MA_ALL_ROUNDS_HEADERS = ['Company name', 'Industry', 'Round name', 'Round date',
  'Investment', 'FMV', 'Raised', 'Post money'] as const;

const MA_ALL_ROUNDS_SORTING = {
  byCompanyName: (round: MaRound): string => round.companyName,
  bySector: (round: MaRound): string => round.sector,
  byRoundName: (round: MaRound): string => round.roundName,
  byRoundDate: (round: MaRound): Date => round.roundDate,
  byCost: (round: MaRound): number => round.cost,
  byFmv: (round: MaRound): number => round.fmv,
  byTotalRound: (round: MaRound): number => round.totalRound,
  byPostMoney: (round: MaRound): number => round.postMoney,
};


const SORT_MAP = {
  0: MA_ALL_ROUNDS_SORTING.byCompanyName,
  1: MA_ALL_ROUNDS_SORTING.bySector,
  2: MA_ALL_ROUNDS_SORTING.byRoundName,
  3: MA_ALL_ROUNDS_SORTING.byRoundDate,
  4: MA_ALL_ROUNDS_SORTING.byCost,
  5: MA_ALL_ROUNDS_SORTING.byFmv,
  6: MA_ALL_ROUNDS_SORTING.byTotalRound,
  7: MA_ALL_ROUNDS_SORTING.byPostMoney,
};
